"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAutoAIAgentsRequest = getAutoAIAgentsRequest;
exports.getAutoAIAgentChatRequest = getAutoAIAgentChatRequest;
exports.sendAutoAIAgentMessageRequest = sendAutoAIAgentMessageRequest;
exports.getAutoAIAgentCurrentMessageRequest = getAutoAIAgentCurrentMessageRequest;
exports.createAutoAIAgentRequest = createAutoAIAgentRequest;
exports.deleteAutoAIAgentRequest = deleteAutoAIAgentRequest;
exports.updateAutoAIAgentNameRequest = updateAutoAIAgentNameRequest;
// Fetches the list of Auto AI Agents for a given branch and user.
async function getAutoAIAgentsRequest(branchId, userId) {
    const response = await fetch(`/dashboard/${userId}/autoai/chat/list?c=${branchId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        cache: 'no-store',
    });
    if (!response.ok) {
        throw new Error('Failed to fetch shift agents');
    }
    const data = await response.json();
    return data.Chats;
}
// Fetches the chat history for a specific Auto AI Agent chat.
async function getAutoAIAgentChatRequest(branchId, userId, chatId, signal) {
    const response = await fetch(`/dashboard/${userId}/autoai/chat/${chatId}?c=${branchId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        cache: 'no-store',
        signal,
    });
    if (!response.ok) {
        throw new Error('Failed to fetch shift agent chat history');
    }
    return response.json();
}
async function sendAutoAIAgentMessageRequest(params) {
    const { branchId, userId, chatId, message, provider, file, signal } = params;
    const formData = new FormData();
    formData.append('message', message);
    formData.append('provider', provider);
    if (file) {
        formData.append('file', file);
    }
    const response = await fetch(`/dashboard/${userId}/autoai/chat/${chatId}/message?c=${branchId}`, {
        method: 'POST',
        body: formData,
        signal,
    });
    if (!response.ok) {
        throw new Error('Failed to send shift agent message');
    }
    return response.json();
}
async function getAutoAIAgentCurrentMessageRequest(branchId, userId, chatId, signal) {
    const response = await fetch(`/dashboard/${userId}/autoai/chat/${chatId}/current?c=${branchId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        cache: 'no-store',
        signal,
    });
    if (!response.ok) {
        throw new Error('Failed to get shift agent reply');
    }
    return response.json();
}
async function createAutoAIAgentRequest(branchId, userId, name) {
    const response = await fetch(`/dashboard/${userId}/autoai/chat?c=${branchId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Name: name }),
    });
    if (!response.ok) {
        throw new Error('Failed to create shift agent');
    }
    const data = await response.json();
    const chatId = data.ChatID;
    if (!chatId) {
        throw new Error('Create shift agent response did not contain a chat ID');
    }
    return { ID: chatId, Name: name };
}
async function deleteAutoAIAgentRequest(branchId, userId, chatId) {
    const response = await fetch(`/dashboard/${userId}/autoai/chat/${chatId}?c=${branchId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        throw new Error('Failed to delete shift agent');
    }
}
async function updateAutoAIAgentNameRequest(branchId, userId, chatId, name) {
    const response = await fetch(`/dashboard/${userId}/autoai/chat/${chatId}?c=${branchId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Name: name }),
    });
    if (!response.ok) {
        throw new Error('Failed to update shift agent name');
    }
}
